import React from "react";
import { Link } from "react-router-dom";
import Icon from "../components/Icon";


export default function ProgramsPage() {
  return (
    <div className="relative">
      <div className="absolute inset-0 celestial-pattern pointer-events-none" />

      <section className="relative pt-16 pb-12 md:pt-24 md:pb-16 page-x max-w-max-width mx-auto text-center">
      <div className="inline-flex items-center gap-2 bg-primary-fixed text-on-primary-fixed px-4 py-1.5 rounded-full mb-6">
      <Icon name="auto_awesome" className="material-symbols-outlined text-[18px]" />
      <span className="font-label-md">Explore Our Cosmic Curriculum</span>
      </div>
      <h1 className="text-display-responsive text-primary mb-6 max-w-3xl mx-auto">
                      Online Quran Programs
                  </h1>
      <p className="font-body-lg text-body-lg text-on-surface-variant max-w-2xl mx-auto">
                      Discover tailored learning journeys designed for all ages and proficiency levels, from the very first letter to deep spiritual mastery.
                  </p>
      </section>

      <section className="py-12 page-x max-w-max-width mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

      <div className="program-card-hover bg-white rounded-2xl border border-outline-variant card-pad transition-all duration-300 relative overflow-hidden group">
      <div className="absolute top-0 right-0 w-24 h-24 bg-tertiary-fixed opacity-10 rounded-bl-full group-hover:scale-150 transition-transform duration-500"></div>
      <div className="bg-primary-container text-on-primary-container w-14 h-14 rounded-xl flex items-center justify-center mb-6">
      <Icon name="abc" className="material-symbols-outlined text-[28px]" />
      </div>
      <h3 className="font-headline-md text-headline-md text-primary mb-3">Noorani Qaida</h3>
      <p className="text-on-surface-variant mb-6 font-body-md">The essential foundation for beginners. Master Arabic alphabet recognition, pronunciation, and basic phonics.</p>
      <div className="flex items-center gap-2 text-tertiary font-label-md mb-8">
      <Icon name="star" className="material-symbols-outlined text-[18px]" filled />
      <span>Best for Beginners</span>
      </div>
      <Link to="/programs/noorani-qaida" className="block w-full text-center bg-surface-container-low text-primary py-3 rounded-full font-bold hover:bg-primary hover:text-white transition-all">View Syllabus</Link>
      </div>

      <div className="program-card-hover bg-white rounded-2xl border border-outline-variant card-pad transition-all duration-300 relative overflow-hidden group">
      <div className="bg-primary-container text-on-primary-container w-14 h-14 rounded-xl flex items-center justify-center mb-6">
      <Icon name="menu_book" className="material-symbols-outlined text-[28px]" />
      </div>
      <h3 className="font-headline-md text-headline-md text-primary mb-3">Quran Reading</h3>
      <p className="text-on-surface-variant mb-6 font-body-md">Transition from basic letters to fluent recitation. Focus on flow, rhythm, and confident reading of any Surah.</p>
      <div className="flex items-center gap-2 text-tertiary font-label-md mb-8">
      <Icon name="star" className="material-symbols-outlined text-[18px]" filled />
      <span>Foundation Level</span>
      </div>
      <Link to="/programs/quran-reading" className="block w-full text-center bg-surface-container-low text-primary py-3 rounded-full font-bold hover:bg-primary hover:text-white transition-all">View Syllabus</Link>
      </div>

      <div className="program-card-hover bg-white rounded-2xl border border-outline-variant card-pad transition-all duration-300 relative overflow-hidden group">
      <div className="bg-primary-container text-on-primary-container w-14 h-14 rounded-xl flex items-center justify-center mb-6">
      <Icon name="music_note" className="material-symbols-outlined text-[28px]" />
      </div>
      <h3 className="font-headline-md text-headline-md text-primary mb-3">Tajweed</h3>
      <p className="text-on-surface-variant mb-6 font-body-md">The science of beautiful recitation. Learn the precise rules of articulation and rhythmic intonation.</p>
      <div className="flex items-center gap-2 text-tertiary font-label-md mb-8">
      <Icon name="star" className="material-symbols-outlined text-[18px]" filled />
      <span>Advanced Accuracy</span>
      </div>
      <Link to="/programs/tajweed" className="block w-full text-center bg-surface-container-low text-primary py-3 rounded-full font-bold hover:bg-primary hover:text-white transition-all">View Syllabus</Link>
      </div>

      <div className="program-card-hover bg-white rounded-2xl border border-outline-variant card-pad transition-all duration-300 relative overflow-hidden group">
      <div className="bg-primary-container text-on-primary-container w-14 h-14 rounded-xl flex items-center justify-center mb-6">
      <Icon name="memory" className="material-symbols-outlined text-[28px]" />
      </div>
      <h3 className="font-headline-md text-headline-md text-primary mb-3">Hifz</h3>
      <p className="text-on-surface-variant mb-6 font-body-md">Memorize the Holy Quran with personalized schedules and systematic revision techniques for long-term retention.</p>
      <div className="flex items-center gap-2 text-tertiary font-label-md mb-8">
      <Icon name="star" className="material-symbols-outlined text-[18px]" filled />
      <span>Lifelong Commitment</span>
      </div>
      <Link to="/programs/hifz" className="block w-full text-center bg-surface-container-low text-primary py-3 rounded-full font-bold hover:bg-primary hover:text-white transition-all">View Syllabus</Link>
      </div>

      <div className="program-card-hover bg-white rounded-2xl border border-outline-variant card-pad transition-all duration-300 relative overflow-hidden group">
      <div className="bg-primary-container text-on-primary-container w-14 h-14 rounded-xl flex items-center justify-center mb-6">
      <Icon name="auto_stories" className="material-symbols-outlined text-[28px]" />
      </div>
      <h3 className="font-headline-md text-headline-md text-primary mb-3">Tafseer</h3>
      <p className="text-on-surface-variant mb-6 font-body-md">Unlock the deep meanings and historical contexts of the verses to apply Quranic wisdom to modern life.</p>
      <div className="flex items-center gap-2 text-tertiary font-label-md mb-8">
      <Icon name="star" className="material-symbols-outlined text-[18px]" filled />
      <span>Deep Understanding</span>
      </div>
      <Link to="/programs/tafseer" className="block w-full text-center bg-surface-container-low text-primary py-3 rounded-full font-bold hover:bg-primary hover:text-white transition-all">View Syllabus</Link>
      </div>

      <div className="program-card-hover bg-white rounded-2xl border border-outline-variant card-pad transition-all duration-300 relative overflow-hidden group">
      <div className="bg-primary-container text-on-primary-container w-14 h-14 rounded-xl flex items-center justify-center mb-6">
      <Icon name="mosque" className="material-symbols-outlined text-[28px]" />
      </div>
      <h3 className="font-headline-md text-headline-md text-primary mb-3">Islamic Studies</h3>
      <p className="text-on-surface-variant mb-6 font-body-md">A comprehensive guide to Fiqh, Seerah, Akhlaq, and Hadith for a holistic spiritual education.</p>
      <div className="flex items-center gap-2 text-tertiary font-label-md mb-8">
      <Icon name="star" className="material-symbols-outlined text-[18px]" filled />
      <span>Comprehensive Deen</span>
      </div>
      <Link to="/programs/islamic-studies" className="block w-full text-center bg-surface-container-low text-primary py-3 rounded-full font-bold hover:bg-primary hover:text-white transition-all">View Syllabus</Link>
      </div>
      </div>
      </section>

      <section className="py-16 md:py-20 page-x max-w-max-width mx-auto overflow-hidden">
      <div className="text-center mb-12">
      <h2 className="text-headline-responsive text-primary mb-4">Program Comparison</h2>
      <p className="text-on-surface-variant max-w-xl mx-auto">Find the perfect path for your spiritual journey at a glance.</p>
      </div>
      <div className="bg-white rounded-3xl border border-outline-variant shadow-lg overflow-hidden">
      <div className="overflow-x-auto">
      <table className="w-full text-left border-collapse">
      <thead>
      <tr className="bg-surface-container-low text-primary">
      <th className="p-6 font-bold font-label-md border-b border-outline-variant">Program Name</th>
      <th className="p-6 font-bold font-label-md border-b border-outline-variant">Best For</th>
      <th className="p-6 font-bold font-label-md border-b border-outline-variant">Difficulty</th>
      <th className="p-6 font-bold font-label-md border-b border-outline-variant">Core Focus</th>
      </tr>
      </thead>
      <tbody className="text-on-surface-variant">
      <tr className="hover:bg-surface-container-lowest transition-colors border-b border-outline-variant">
      <td className="p-6 font-bold text-primary">Noorani Qaida</td>
      <td className="p-6">Kids &amp; Absolute Beginners</td>
      <td className="p-6"><span className="px-3 py-1 bg-primary-fixed text-on-primary-fixed rounded-full text-xs">Beginner</span></td>
      <td className="p-6">Alphabet &amp; Pronunciation</td>
      </tr>
      <tr className="hover:bg-surface-container-lowest transition-colors border-b border-outline-variant">
      <td className="p-6 font-bold text-primary">Quran Reading</td>
      <td className="p-6">New Muslims &amp; Returners</td>
      <td className="p-6"><span className="px-3 py-1 bg-primary-fixed text-on-primary-fixed rounded-full text-xs">Beginner</span></td>
      <td className="p-6">Fluency &amp; Word Recognition</td>
      </tr>
      <tr className="hover:bg-surface-container-lowest transition-colors border-b border-outline-variant">
      <td className="p-6 font-bold text-primary">Tajweed</td>
      <td className="p-6">Intermediate Students</td>
      <td className="p-6"><span className="px-3 py-1 bg-tertiary-fixed text-on-tertiary-fixed rounded-full text-xs">Intermediate</span></td>
      <td className="p-6">Precision &amp; Vocal Rules</td>
      </tr>
      <tr className="hover:bg-surface-container-lowest transition-colors border-b border-outline-variant">
      <td className="p-6 font-bold text-primary">Hifz</td>
      <td className="p-6">Dedicated Memorizers</td>
      <td className="p-6"><span className="px-3 py-1 bg-secondary-fixed text-on-secondary-fixed rounded-full text-xs">Intensive</span></td>
      <td className="p-6">Retention &amp; Review</td>
      </tr>
      <tr className="hover:bg-surface-container-lowest transition-colors border-b border-outline-variant">
      <td className="p-6 font-bold text-primary">Tafseer</td>
      <td className="p-6">Knowledge Seekers</td>
      <td className="p-6"><span className="px-3 py-1 bg-tertiary-fixed text-on-tertiary-fixed rounded-full text-xs">Intermediate</span></td>
      <td className="p-6">Translation &amp; Context</td>
      </tr>
      <tr className="hover:bg-surface-container-lowest transition-colors border-b border-outline-variant">
      <td className="p-6 font-bold text-primary">Islamic Studies</td>
      <td className="p-6">Families &amp; Youth</td>
      <td className="p-6"><span className="px-3 py-1 bg-primary-fixed text-on-primary-fixed rounded-full text-xs">All Levels</span></td>
      <td className="p-6">Holistic Life Guidance</td>
      </tr>
      </tbody>
      </table>
      </div>
      </div>
      </section>

      <section className="section-y page-x max-w-max-width mx-auto">
      <div className="gradient-mesh rounded-section p-8 md:p-16 flex flex-col md:flex-row items-center justify-between border border-primary-fixed/30 gap-8">
      <div className="max-w-xl">
      <h2 className="text-display-responsive text-primary mb-4">Still unsure which path to take?</h2>
      <p className="text-body-lg text-on-surface-variant">Our expert advisors are here to help you or your child find the most effective starting point based on current knowledge and future goals.</p>
      </div>
      <div className="flex flex-col sm:flex-row gap-4 w-full md:w-auto">
      <Link to="/contact" className="bg-primary text-on-primary px-6 sm:px-8 py-3 sm:py-4 rounded-full w-full sm:w-auto text-center font-bold flex items-center justify-center gap-2 hover:shadow-xl hover:scale-105 transition-all">
      <Icon name="whatshot" className="material-symbols-outlined" />
                              WhatsApp Now
      </Link>
      <Link to="/contact" className="bg-white border border-primary text-primary px-6 sm:px-8 py-3 sm:py-4 rounded-full w-full sm:w-auto text-center font-bold flex items-center justify-center gap-2 hover:bg-surface-container-low transition-all">
      <Icon name="mail" className="material-symbols-outlined" />
                              Contact Us
      </Link>
      </div>
      </div>
      </section>

      <section className="py-16 md:py-20 page-x max-w-max-width mx-auto">
      <div className="relative h-56 sm:h-72 md:h-[400px] rounded-section overflow-hidden group">
      <img alt="Global community of Quran learners" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" src="https://lh3.googleusercontent.com/aida-public/AB6AXuB2EemUqctDtV2QD6dEX02mFoIn1VT6n8Is9UedODrQhoXiPB9How1I3ZLGSbUjfr1qUGEz-6ofV275Uf511-HNz9lHUTdPZFpwCrLsZ692OOPfeddncN1u0Pvh-JOyjy1XuUleiCGGRgNsq6ScBSrqWmk2ETHUL0xJqlnaB43iPDoBxGupu-J2mOdXelPJOHONTaFN_vHEMIpB7AIRN9ic0UtiLH3sHl6tPkU5GJMqvgGvTanchbN0ac8noM0w3wLlsXxPn0q-c_sK"/>
      <div className="absolute inset-0 bg-gradient-to-t from-primary/60 to-transparent"></div>
      <div className="absolute bottom-12 left-12 text-white">
      <p className="text-headline-responsive mb-2">Join a global community of learners</p>
      <p className="font-body-lg opacity-90">Over 5,000+ students across 40 countries.</p>
      </div>
      </div>
      </section>
    </div>
  );
}
